import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { deAT, enUS } from 'date-fns/locale'
import { useTranslation } from 'react-i18next'

/**
 * Provides the `LocalizationProvider` needed for all date and time pickers.
 * Automatically sets the current *i18n* locale as the locale in the `LocalizationProvider`.
 */
export const I18NAwareLocalizationProvider: React.FC<
    React.PropsWithChildren
> = ({ children }) => {
    const [, { language }] = useTranslation()

    return (
        <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={language === 'de' ? deAT : enUS}
        >
            {children}
        </LocalizationProvider>
    )
}
